var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import * as Enumerable from "linq";
import { autoinject } from "aurelia-dependency-injection";
import { noView } from "aurelia-templating";
import { customAttribute } from "aurelia-templating";
import { bindable } from "aurelia-templating";
import { LookupClientService } from "../../../../services/lookups/lookup-client.service";
import { LookupValueRequest } from "../../../../models/lookups/lookup.models";
var LookupPropertyCustomAttribute = /** @class */ (function () {
    function LookupPropertyCustomAttribute(element, lookupsClientService) {
        this.element = element;
        this.lookupsClientService = lookupsClientService;
        this.format = "{name}";
    }
    LookupPropertyCustomAttribute.prototype.idChanged = function (newValue, oldValue) {
        this.invalidate();
    };
    LookupPropertyCustomAttribute.prototype.formatChanged = function (newValue, oldValue) {
        this.invalidate();
    };
    LookupPropertyCustomAttribute.prototype.queryChanged = function (newValue, oldValue) {
        this.invalidate();
    };
    LookupPropertyCustomAttribute.prototype.parametersChanged = function (newValue, oldValue) {
        this.invalidate();
    };
    LookupPropertyCustomAttribute.prototype.invalidate = function () {
        var _this = this;
        if (this.query && this.id) {
            var lookupValueRequest = this.createLookupValueRequest();
            this.lookupsClientService.getLookup(lookupValueRequest, true)
                .then(function (response) {
                if (response) {
                    var item = Enumerable.from(response.values).firstOrDefault(function (x) { return x.id == _this.id; });
                    var value = _this.getString(item);
                    if (!value)
                        value = _this.searchById(_this.id, response.values, 0);
                    _this.element.innerHTML = value;
                }
                else {
                    _this.element.innerHTML = "";
                }
            }, function (e) {
                _this.element.innerHTML = "";
            });
        }
        else {
            this.element.innerHTML = "";
        }
    };
    LookupPropertyCustomAttribute.prototype.searchById = function (id, lookupValues, level) {
        var e_1, _a;
        if (lookupValues) {
            try {
                for (var lookupValues_1 = __values(lookupValues), lookupValues_1_1 = lookupValues_1.next(); !lookupValues_1_1.done; lookupValues_1_1 = lookupValues_1.next()) {
                    var lookupValue = lookupValues_1_1.value;
                    var value = lookupValue.id == id ? lookupValue : null;
                    if (value) {
                        return this.getString(value);
                    }
                    else if (lookupValue.children && lookupValue.children.length > 0) {
                        var childrenResult = this.searchById(id, lookupValue.children, level + 1);
                        if (childrenResult !== null) {
                            return childrenResult;
                        }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (lookupValues_1_1 && !lookupValues_1_1.done && (_a = lookupValues_1.return)) _a.call(lookupValues_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return null;
    };
    LookupPropertyCustomAttribute.prototype.getString = function (item) {
        if (!item)
            return "";
        var str = this.format;
        for (var x in item) {
            var pattern = new RegExp("{" + x + "}", "g");
            str = str.replace(pattern, item[x]);
        }
        if (item.additionalData)
            for (var x in item.additionalData) {
                var pattern = new RegExp("{" + x + "}", "g");
                str = str.replace(pattern, item.additionalData[x]);
            }
        return str;
    };
    LookupPropertyCustomAttribute.prototype.createLookupValueRequest = function () {
        var request = new LookupValueRequest();
        request.lookupValueQuery = this.query;
        request.parameters = this.parameters;
        return request;
    };
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], LookupPropertyCustomAttribute.prototype, "id", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], LookupPropertyCustomAttribute.prototype, "query", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], LookupPropertyCustomAttribute.prototype, "parameters", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], LookupPropertyCustomAttribute.prototype, "format", void 0);
    LookupPropertyCustomAttribute = __decorate([
        customAttribute("lookup-property"),
        noView,
        autoinject,
        __metadata("design:paramtypes", [Element,
            LookupClientService])
    ], LookupPropertyCustomAttribute);
    return LookupPropertyCustomAttribute;
}());
export { LookupPropertyCustomAttribute };
